/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabTestItemOrganismAntibiotic from './lab-test-item-organism-antibiotic';
import LabTestItemOrganismAntibioticDetail from './lab-test-item-organism-antibiotic-detail';
import LabTestItemOrganismAntibioticUpdate from './lab-test-item-organism-antibiotic-update';
import LabTestItemOrganismAntibioticDeleteDialog from './lab-test-item-organism-antibiotic-delete-dialog';

const LabTestItemOrganismAntibioticRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabTestItemOrganismAntibiotic />} />
    <Route path="new" element={<LabTestItemOrganismAntibioticUpdate />} />
    <Route path=":id">
      <Route index element={<LabTestItemOrganismAntibioticDetail />} />
      <Route path="edit" element={<LabTestItemOrganismAntibioticUpdate />} />
      <Route path="delete" element={<LabTestItemOrganismAntibioticDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabTestItemOrganismAntibioticRoutes;
